import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChildren,
  input,
  Signal,
  viewChild,
} from '@angular/core';
import { ButtonModule, ExpansionPanelModule } from '@pin-up-global/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { filter, startWith, switchMap } from 'rxjs';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'ca-menu-item',
  standalone: true,
  imports: [
    ExpansionPanelModule,
    RouterLink,
    RouterLinkActive,
    NgTemplateOutlet,
    AsyncPipe,
    ButtonModule,
    MatIcon,
  ],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'ca-menu-item',
    '[class.ca-menu-item_active]': 'isActive()',
    '[class.ca-menu-item_disabled]': 'isDisabled()',
    '[class.ca-menu-item_collapsed]': 'isCollapsed()',
  },
})
export class MenuItemComponent {
  routerLinkActive = viewChild(RouterLinkActive);
  projectedMenuItems = contentChildren(MenuItemComponent);

  icon = input<string>();
  label = input.required<string>();
  link = input<string>();
  isDisabled = input<boolean, unknown>(false, { transform: booleanAttribute });
  isCollapsed = input<boolean, unknown>(false, { transform: booleanAttribute });

  routerLinkActive$ = toObservable(this.routerLinkActive);
  isActiveChange = toSignal(this.routerLinkActive$.pipe(
    filter(Boolean),
    switchMap((routerLinkActive) => routerLinkActive.isActiveChange.pipe(startWith(routerLinkActive.isActive))),
  ));
  isActive: Signal<boolean> = computed(() => {
    return this.isActiveChange() ||
      this.projectedMenuItems()
          .some(menuItem => menuItem.isActive());
  });
  hasProjectedMenuItems = computed(() => !!this.projectedMenuItems().length);
}
